import styled, { css } from 'styled-components';
import { colorPrimary } from '../../theme';

export const Container = styled.div<{ $fullScreen?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 48px;
	color: ${colorPrimary};

	span {
		font-size: 24px;
		display: block;
		color: #000;
		text-align: center;
	}

	span:nth-child(3) {
		margin-top: 4px;
		font-size: 16px;
	}

	${({ $fullScreen }) =>
		$fullScreen &&
		css`
			height: calc(100vh - 200px);
		`}
`;
